import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { convertApiItemResponseToItem } from '@shared/core/utils';
import { CrmApiService } from '@shared/core';
import { PdType, Person, PersonPersonalDataResponse, PersonResponse } from '@crm/shared/persons/types';
import { DEFAULT_REQUEST_PARAMS, EntityId } from '@shared/core/types';
import { PersonIdByServiceId, PersonIdByServiceIdResponse } from '../../../../cabinet/types';

@Injectable({
  providedIn: 'root',
})
export class PersonApiSharedService extends CrmApiService {
  getPerson(personId: EntityId, debugParam?: string): Observable<Person> {
    // debugParam is needed for CRM2PB-4880 and will be removed later
    return this.api
      .get<PersonResponse>(`${this.baseEndpoint}persons/${personId}`, {
        params: {
          crm2: true,
          debugParam,
        },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        convertApiItemResponseToItem,
        catchError(() => of(null)),
      );
  }

  getPersonalData(personId: EntityId, pdType: PdType, source: string, contactUuid?: string): Observable<string> {
    return this.api
      .get<PersonPersonalDataResponse>(`${this.baseEndpoint}persons/${personId}/personal-data/`, {
        params: {
          pdType,
          source,
          uuid: contactUuid,
        },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        convertApiItemResponseToItem,
        map(pd => pd.value),
        catchError(() => of(undefined)),
      );
  }

  getPersonIdsByServiceIds(educationServiceIds: number[]): Observable<PersonIdByServiceId[]> {
    return this.api
      .get<PersonIdByServiceIdResponse>(`${this.baseEndpoint}persons/by-education-service-ids/`, {
        params: { ids: educationServiceIds },
        ...DEFAULT_REQUEST_PARAMS,
      })
      .pipe(
        convertApiItemResponseToItem,
        catchError(() => of([])),
      );
  }
}
